import { render } from "./editAdmin.vue?vue&type=template&id=ee091246&scoped=true"
import script from "./editAdmin.vue?vue&type=script&lang=js"
export * from "./editAdmin.vue?vue&type=script&lang=js"

import "./editAdmin.vue?vue&type=style&index=0&id=ee091246&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee091246"]])

export default __exports__